var map = {
	"./2012.json": 1827,
	"./2013.json": 4304,
	"./2014.json": 4217,
	"./2015.json": 6110,
	"./2016.json": 3551,
	"./2017.json": 8188,
	"./2018.json": 3301,
	"./2019.json": 6618,
	"./2020.json": 2982,
	"./2021.json": 7937,
	"./2022.json": 1956,
	"./2023.json": 6343,
	"./2024.json": 4298,
	"./2025.json": 7813,
	"./2026.json": 6248,
	"./2027.json": 3787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7487;